module.exports = __webpack_public_path__ + "static/media/video-polanco-noche.cd7d97dc.jpg";